import { render, staticRenderFns } from "./SpermSentReceivedTable.vue?vue&type=template&id=bb56aeba&"
import script from "./SpermSentReceivedTable.vue?vue&type=script&lang=js&"
export * from "./SpermSentReceivedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports